export default __webpack_public_path__ + "5639d0d5310782841b86423094f74713.svg";